module.exports = __webpack_public_path__ + "img/Slide44.dea7843f.png";